export const handleSelectedCandidatesLimit = (data) =>
  data.list
    .filter((candidate) => candidate.isSelected)
    .map((candidate) => (candidate.isSelected = false));
